import styled from 'styled-components';

export const Container = styled.div`
  .bd-add-new-cat {
    border: 1px solid #ff6900;
    p {
      color: #ff6900;
    }
  }

  .max-w {
    width: 90px;
  }

  .input-height {
    height: 25px;
  }

  .check {
    color: #6a6a6a;
    font-size: 14px;
    font-weight: 500;
    span:nth-child(2) {
      border-radius: 4px;
      border: 1px solid #c7c7c7;
      width: 24px !important;
      height: 24px !important;
    }
  }

  .checked {
    background: #ff842f !important;
  }

  input::placeholder {
    color: #d8d8d8;
  }
`;
